/* ADSCALAR — storefront event layer.

   Emits the GA4 funnel (view_item → add_to_cart → view_cart → begin_checkout)
   onto window.dataLayer, and the Meta equivalents through fbq. `purchase` is
   NOT here: it lives in a Customer Events custom pixel, because Shopify's
   thank-you page never renders this theme and the order-status Additional
   Scripts field was removed on 26 Aug 2026.

   Every event carries an event_id. Reuse it as the Conversions API `event_id`
   when the server-side relay goes in, and Meta will deduplicate the pair
   instead of double-counting. IDs are kept in sessionStorage so a relay can
   read back what the browser already sent. */
(function () {
  var cfg = window.ascTrackConfig;
  if (!cfg) return;

  var CURRENCY = cfg.currency || 'INR';
  var STORE_KEY = 'asc-track-event-ids';

  function log() {
    if (!cfg.debug) return;
    try {
      console.log.apply(console, ['[asc-track]'].concat([].slice.call(arguments)));
    } catch (e) {}
  }

  function eventId() {
    try {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    } catch (e) {}
    return 'ek-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  // Keep a short trail so a CAPI relay can match browser events it did not send.
  function remember(name, id, payload) {
    try {
      var all = JSON.parse(window.sessionStorage.getItem(STORE_KEY) || '[]');
      all.push({ event: name, event_id: id, at: Date.now(), value: payload.value || 0 });
      window.sessionStorage.setItem(STORE_KEY, JSON.stringify(all.slice(-25)));
    } catch (e) {}
  }

  // GA4 event -> Meta standard event.
  var META_MAP = {
    view_item: 'ViewContent',
    add_to_cart: 'AddToCart',
    view_cart: 'ViewCart',
    begin_checkout: 'InitiateCheckout'
  };

  function metaContents(items) {
    return (items || []).map(function (i) {
      return { id: String(i.item_id), quantity: i.quantity || 1, item_price: i.price || 0 };
    });
  }

  function push(name, items, value) {
    var id = eventId();
    var list = items || [];
    var total = typeof value === 'number' ? value : list.reduce(function (s, i) {
      return s + (i.price || 0) * (i.quantity || 1);
    }, 0);

    var ecommerce = { currency: CURRENCY, value: Number(total.toFixed(2)), items: list };

    // Null the previous object first, or GTM merges stale items into this hit.
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: name, event_id: id, ecommerce: ecommerce });

    if (window.fbq && META_MAP[name]) {
      window.fbq(
        'track',
        META_MAP[name],
        {
          currency: CURRENCY,
          value: ecommerce.value,
          content_type: 'product',
          content_ids: list.map(function (i) { return String(i.item_id); }),
          contents: metaContents(list)
        },
        { eventID: id }
      );
    }

    remember(name, id, ecommerce);
    log(name, id, ecommerce);
    return id;
  }

  function readJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // ── view_item ────────────────────────────────────────────────────────────
  var pdp = readJSON(document.querySelector('[data-asc-track-product]'));
  if (pdp) push('view_item', [pdp], pdp.price);

  // ── add_to_cart ──────────────────────────────────────────────────────────
  // asc-pdp.js dispatches this once /cart/add.js resolves, with the variant it
  // actually added, so the value reflects the real line rather than a guess.
  window.addEventListener('ek:add-to-cart', function (e) {
    var d = (e && e.detail) || {};
    var base = pdp || {};
    push(
      'add_to_cart',
      [
        {
          item_id: d.sku || d.variant_id || base.item_id,
          item_name: d.product_title || base.item_name,
          item_variant: d.variant_title || base.item_variant,
          item_brand: base.item_brand,
          item_category: base.item_category,
          price: typeof d.price === 'number' ? d.price : base.price,
          quantity: d.quantity || 1
        }
      ],
      (typeof d.price === 'number' ? d.price : base.price || 0) * (d.quantity || 1)
    );
  });

  var cartRequest = null;
  function currentCart() {
    if (cartRequest) return cartRequest;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    cartRequest = fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); })
      .then(function (cart) {
        cfg.cartTotal = cart.total_price / 100;
        cfg.cartCount = cart.item_count;
        cfg.cartItems = cart.items.map(function (item) {
          return { item_id: item.sku || item.variant_id, item_name: item.product_title, item_variant: item.variant_title,
            item_brand: item.vendor, item_category: item.product_type, price: item.final_price / 100, quantity: item.quantity };
        });
        return cart;
      }).finally(function () { cartRequest = null; });
    return cartRequest;
  }
  var lastCartView = '';
  function reportCart() {
    currentCart().then(function (cart) {
      var signature = JSON.stringify([cart.total_price, cart.items.map(function (item) { return [item.key, item.quantity]; })]);
      if (signature === lastCartView) return;
      lastCartView = signature;
      push('view_cart', cfg.cartItems, cfg.cartTotal);
    }).catch(function () {});
  }
  window.addEventListener('ek:magic-cart-visible', reportCart);
  if (location.pathname.replace(/\/$/, '') === '/cart') reportCart();
  var checkoutReported = false;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('button[name="checkout"]');
    if (!button || checkoutReported) return;
    checkoutReported = true;
    setTimeout(function () { checkoutReported = false; }, 4000);
    currentCart().then(function () { push('begin_checkout', cfg.cartItems, cfg.cartTotal); }).catch(function () {});
  }, true);
  window.addEventListener('ek:magic-checkout-click', function () {
    currentCart().then(function () {
      window.dataLayer.push({ event: 'ek_magic_checkout_click', ecommerce: { currency: CURRENCY, value: cfg.cartTotal, items: cfg.cartItems } });
    }).catch(function () {});
  });

  window.ascTrack = { push: push, eventId: eventId };
})();
